// extracted by mini-css-extract-plugin
module.exports = {"assessment-button":"style_assessment-button__1ikfH"};